import axiosClient from './axiosClient';

const settingsApi = {
  // Tipo de cambio USD -> PEN general y el propio del rol distribuidor (solo administrador)
  getExchangeRate: () => axiosClient.get('/settings/exchange-rate'),
  updateExchangeRate: (exchange_rate, exchange_rate_distribuidor) =>
    axiosClient.put('/settings/exchange-rate', { exchange_rate, exchange_rate_distribuidor }),
};

export default settingsApi;
